/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BalanceLineType = {
    Fee: 'Fee',
    Tuition: 'Tuition',
    Discount: 'Discount',
    Adjustment: 'Adjustment',
    Session: 'Session',
    Refund: 'Refund',
    Payment: 'Payment',
    WriteOff: 'WriteOff',
    Credit: 'Credit'
} as const;
export type BalanceLineType = typeof BalanceLineType[keyof typeof BalanceLineType];


export function instanceOfBalanceLineType(value: any): boolean {
    for (const key in BalanceLineType) {
        if (Object.prototype.hasOwnProperty.call(BalanceLineType, key)) {
            if (BalanceLineType[key as keyof typeof BalanceLineType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BalanceLineTypeFromJSON(json: any): BalanceLineType {
    return BalanceLineTypeFromJSONTyped(json, false);
}

export function BalanceLineTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceLineType {
    return json as BalanceLineType;
}

export function BalanceLineTypeToJSON(value?: BalanceLineType | null): any {
    return value as any;
}

export function BalanceLineTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BalanceLineType {
    return value as BalanceLineType;
}

